import type { ChainLpcLppSupplierPropertyGroup, ChainLpcLppSupplierRollup } from '~/types/services/priceParrot';

import { HOTSPOT_RATIO_THRESHOLD, PERIOD_PRESETS } from './constants';

export function hasLppSupplier(group: ChainLpcLppSupplierPropertyGroup): boolean {
  return group.rows.some((r) => r.channel === 'LPP');
}

export function emptyStateMessage(mixedSppOnly: boolean, hotspotsOnly: boolean, region: string | null): string {
  const activeFilters: Array<string> = [];
  if (mixedSppOnly) {
    activeFilters.push('both LPC and LPP bookings');
  }
  if (hotspotsOnly) {
    activeFilters.push(`a ratio below ${HOTSPOT_RATIO_THRESHOLD}`);
  }
  if (region) {
    activeFilters.push(`the "${region}" region`);
  }
  if (activeFilters.length === 0) {
    return 'No properties for this chain in the selected range.';
  }
  return `No properties matching ${activeFilters.join(' and ')} for this chain in the selected range.`;
}

export function computeRollup(properties: ReadonlyArray<ChainLpcLppSupplierPropertyGroup>): ChainLpcLppSupplierRollup {
  let bookingsCount = 0;
  let marginArAud = 0;
  let lpcViews: number | null = null;
  let lppViews: number | null = null;
  for (const group of properties) {
    for (const row of group.rows) {
      bookingsCount += row.bookings_count;
      marginArAud += row.margin_ar_aud;
    }
    if (group.lpc_views != null) {
      lpcViews = (lpcViews ?? 0) + group.lpc_views;
    }
    if (group.lpp_views != null) {
      lppViews = (lppViews ?? 0) + group.lpp_views;
    }
  }
  return {
    bookings_count: bookingsCount,
    margin_ar_aud: marginArAud,
    avg_margin_per_booking_aud: bookingsCount > 0 ? marginArAud / bookingsCount : null,
    lpc_views: lpcViews,
    lpp_views: lppViews,
  };
}

export function errMsg(err: unknown): string {
  if (!err) {
    return '';
  }
  return err instanceof Error ? err.message : JSON.stringify(err);
}

export function presetKeyFor(indices: [number, number], calendarLength: number): string | null {
  const maxIdx = calendarLength - 1;
  if (maxIdx < 0 || indices[1] !== maxIdx) {
    return null;
  }
  const span = indices[1] - indices[0] + 1;
  return PERIOD_PRESETS.find((p) => p.days === span)?.key ?? null;
}
